var root = require('./_root');

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;



//////////////////
// WEBPACK FOOTER
// ./~/_lodash@4.17.4@lodash/_Uint8Array.js
// module id = 1403
// module chunks = 0